import React from 'react';
import moment from 'moment';
import { useAppSelector } from 'store';
import { selectUserDocuments } from 'store/slice/userSlice';
import './documents.scss';

export const DocumentsUploadedList = () => {
  const docs = useAppSelector(selectUserDocuments);

  if (!docs.length) return null;

  return (
    <ol>
      {docs.map((d: any, index: number) => (
        <li key={d.id} style={{ marginBottom: 12 }}>
          {index + 1}. <b>{d.file_name}</b> {moment.unix(d.created_at).format('DD.MM.YYYY HH:mm')} (
          {d.status})
        </li>
      ))}
    </ol>
  );
};
